import React from 'react';
import _ from 'lodash';

import DeleteIcon from '../../images/icon/icon--delete-7.svg';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { TextField } from '@bld/bld-libs/components';

import { messageUtility } from '../../utilities/messageUtility';
import { BOARD_MAX_LENGTH } from '../../utilities/constants';

import Styles from '../../styles/componentStyle/fieldBulletinBoard/FieldBulletinBoardForm.scss';

/**
 * 現場掲示板 お知らせ内容
 * @param { function } handleChangeData
 * @param { function } validateFormItem
 * @param { function } handleFileUpload
 * @param { function } handleFileDelete
 * @param { Ref } fileRef
 * @param { Object } data
 * @param { Array } uploadFiles
 * @param { Object } formErrorMessage
 * @param { Object } fileErrorMessage
 * @returns { JSX.Element }
 */
export function FieldBulletinBoardContents({
  handleChangeData,
  validateFormItem,
  handleFileUpload,
  handleFileDelete,
  fileRef,
  data,
  uploadFiles,
  formErrorMessage,
  fileErrorMessage,
}) {
  return (
    <React.Fragment>
      <div className={`${Styles.contents}`}>
        <div className='form-group'>
          <div className='bulletin-board-form-list'>
            <div className='form-item'>
              <span className='form__label'>
                {messageUtility.getMessage('I-000-165-26')}
                <span className='form__required'>
                  {messageUtility.getMessage('I-000-165-17')}
                </span>
              </span>
              <TextField
                className='form__single-txt'
                placeholder={messageUtility.getMessage('I-000-165-14')}
                value={data.title}
                onChange={event =>
                  handleChangeData({ title: event.target.value })
                }
                onBlur={() => validateFormItem('title')}
                error={
                  _.has(formErrorMessage, 'title') &&
                  !_.isEmpty(formErrorMessage.title)
                }
                helperText={
                  _.has(formErrorMessage, 'title') &&
                  !_.isEmpty(formErrorMessage.title)
                    ? formErrorMessage.title
                    : ''
                }
                maxLength={BOARD_MAX_LENGTH.title}
              />
            </div>
            <div className='form-item'>
              <span className='form__label'>
                {messageUtility.getMessage('I-000-165-27')}
              </span>
              <div className='form-importance'>
                <FormControlLabel
                  control={
                    <Checkbox
                      sx={{
                        '& .MuiSvgIcon-root': { fontSize: 24, fill: '#1976d2' },
                      }}
                    />
                  }
                  onChange={event =>
                    handleChangeData({ importance_type: event.target.checked })
                  }
                  checked={data.importance_type ? true : false}
                  label={messageUtility.getMessage('I-000-165-28')}
                  sx={{ '.MuiTypography-root': { fontSize: 13 } }}
                />
                <span className='form-description__txt'>
                  {messageUtility.getMessage('I-000-165-34')}
                </span>
              </div>
            </div>
            <div className='form-item flex-start'>
              <span className='form__label'>
                {messageUtility.getMessage('I-000-165-29')}
                <span className='form__required'>
                  {messageUtility.getMessage('I-000-165-17')}
                </span>
              </span>
              <TextField
                className='form__multi-txt'
                multiline
                rows={4}
                placeholder={messageUtility.getMessage('I-000-165-15')}
                value={data.contents}
                onChange={event =>
                  handleChangeData({ contents: event.target.value })
                }
                onBlur={() => validateFormItem('contents')}
                error={
                  _.has(formErrorMessage, 'contents') &&
                  !_.isEmpty(formErrorMessage.contents)
                }
                helperText={
                  _.has(formErrorMessage, 'contents') &&
                  !_.isEmpty(formErrorMessage.contents)
                    ? formErrorMessage.contents
                    : ''
                }
                sx={{
                  '& .MuiInputBase-root': {
                    '& .MuiOutlinedInput-root': {
                      verticalAlign: 'top', // 他のブラウザ向けにも指定
                      alignItems: 'top', // 他のブラウザ向けにも指定
                    },
                  },
                }}
                maxLength={BOARD_MAX_LENGTH.contents}
              />
            </div>
            <div className='form-item flex-start'>
              <span className='form__label'>
                {messageUtility.getMessage('I-000-165-30')}
              </span>
              <div className='form-board-files'>
                {/* アップロードファイル表示エリア (エラー発生ファイルは赤字で表示) */}
                {!_.isEmpty(uploadFiles) &&
                  _.map(uploadFiles, (val, key) => {
                    return (
                      <div key={key} className='board-upload-files'>
                        <span
                          className={
                            _.has(formErrorMessage, 'files') &&
                            _.has(formErrorMessage.files, key) &&
                            !_.isEmpty(formErrorMessage.files[key])
                              ? 'board-file-name error-file'
                              : 'board-file-name'
                          }
                        >
                          {uploadFiles[key].name}
                        </span>
                        <button
                          className='file-delete-btn'
                          onClick={() => handleFileDelete(key)}
                        >
                          <img className='file-delete-icon' src={DeleteIcon} />
                        </button>
                      </div>
                    );
                  })}
                {/* アップロードファイル表示エリア (エラー発生ファイルは赤字で表示) */}
                {!_.isEmpty(fileErrorMessage) &&
                  _.map(fileErrorMessage, (message, key) => {
                    return (
                      <div key={key} className='form-file-input__error'>
                        <span className='form-file-input__error-txt'>
                          {message}
                        </span>
                      </div>
                    );
                  })}

                <div className='form-file-input'>
                  <input
                    name='fileInput'
                    type='file'
                    style={{ display: 'none' }}
                    ref={fileRef}
                    onChange={event => {
                      handleFileUpload(event);
                      event.target.value = '';
                    }}
                  />
                  <button
                    className='file-input-btn'
                    onClick={() => fileRef.current.click()}
                  >
                    <AddCircleIcon className='file-icon' />
                    {messageUtility.getMessage('I-000-165-31')}
                  </button>
                </div>
                <span className='form-description__txt'>
                  {messageUtility.getMessage('I-000-165-32')}
                </span>
                <span className='form-description__txt'>
                  {messageUtility.getMessage('I-000-165-33')}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/components/fieldBulletinBoard/FieldBulletinBoardContents.jsx